import { formatAddress } from "./address"

export const formatTokenId = formatAddress
